import React, { useEffect } from 'react';

const Mission = () => {
  useEffect(() => { document.title = 'Mission | Afterimage Labs'; }, []);

  return (
    <main>
      <section className="ai-pagehead">
        <div className="ai-wrap">
          <h1>Most missed diagnoses are never looked at again.</h1>
          <p>
            The patient usually doesn't know. The hospital rarely hears about it.
            The same gap catches the next person. We think the record should be
            read, and what it shows should reach the people who need it.
          </p>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>For patients and families</h2>
          <div className="ai-body">
            <p>
              Your medical records belong to you. Even so, most people never learn
              whether their diagnosis came late. Finding out means requesting the
              records, chasing the ones that don't arrive, and reading hundreds of
              pages of clinical shorthand. Few people get through all of it.
            </p>
            <p>
              We do that work and give you a straight answer from your own chart.
              What you do with it is up to you.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>For attorneys</h2>
          <div className="ai-body">
            <p>
              Deciding whether a case has merit starts with the records, and
              getting and reading them is slow and expensive. Most of that cost
              lands before anyone knows if the case is worth taking.
            </p>
            <p>
              We deliver the complete chart and a timeline of the care, with the
              points where a diagnosis could have come sooner marked and checked
              by a person. The review reports what the record shows, whichever
              side that helps.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>For hospitals and clinics</h2>
          <div className="ai-body">
            <p>
              The same review that answers one question also shows where a system
              keeps failing: the imaging result that doesn't reach the ordering
              doctor, the referral that quietly expires. Providers rarely see these
              patterns because nobody puts the cases side by side.
            </p>
            <p>
              We do, and we share what we find in a form a quality team can act on.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>Why reading the records matters</h2>
          <div className="ai-body">
            <p>
              Hospitals already know diagnostic errors are common. What's usually
              missing is the evidence: which cases, which step failed, how often.
              Once that's written down, fixing the problem gets easier to justify
              than living with it. It starts with someone reading the records.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>How we work</h2>
          <div className="ai-pairs">
            <div>
              <h3>Straight answers</h3>
              <p>We tell whoever asked what the chart shows, whether or not it's the answer they hoped for.</p>
            </div>
            <div>
              <h3>The record decides</h3>
              <p>We say what the chart shows and nothing more. A weak case gets an honest no.</p>
            </div>
            <div>
              <h3>Not anti-doctor</h3>
              <p>Most errors come from broken systems, not bad people. We'd rather fix the system.</p>
            </div>
            <div>
              <h3>Software where it helps</h3>
              <p>Machines read fast. People make the judgment calls. We use both for what they're good at.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Mission;
